import React from "react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { EntityTag, useEntityDetailOptional } from "#app/components/entity";
import type { EntityKind, EntityMentionOptions } from "./entity-mention";
import {
  fallbackMentionEntity,
  issueOpenConfirm,
  type EntityMentionRef,
} from "./mention-refs";

export function EntityChip(props: NodeViewProps) {
  const { node, extension } = props;
  const options = extension.options as EntityMentionOptions;
  const detail = useEntityDetailOptional();

  const ref: EntityMentionRef = {
    kind: (node.attrs.entity ?? "user") as EntityKind,
    id: node.attrs.id as string,
    label: (node.attrs.label as string) ?? (node.attrs.id as string),
    workflowId: (node.attrs.workflowId as string) ?? undefined,
  };

  const entity = options.resolveEntity?.(ref) ?? fallbackMentionEntity(ref);

  const handlePress = () => {
    detail?.openEntity(entity.kind, entity.id);
  };

  // createElement (not JSX) marks the raw inline-flow DOM wrapper as a reviewed editor-module escape hatch.
  return React.createElement(
    NodeViewWrapper,
    { as: "span", className: "entity-chip", contentEditable: false },
    <EntityTag
      entity={entity}
      variant="chip"
      // A mention of a team the viewer can't open has no destination — inert.
      interactive={detail ? detail.canOpenEntity(entity.kind, entity.id) : true}
      onClick={handlePress}
      confirmOnClick={issueOpenConfirm(entity)}
    />,
  );
}
